import { motion } from "framer-motion";
import { ArrowUpRight, Bot } from "lucide-react";
import { Reveal, Overline } from "@/components/Sections";
import { ABOUT, IMAGES, DIGIMONK_SITE } from "@/data";

export default function AboutSection() {
  return (
    <section id="about" className="py-24 md:py-36" data-testid="about-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        {/* Copy */}
        <div>
          <Reveal><Overline>{ABOUT.overline}</Overline></Reveal>
          <Reveal i={1}>
            <h2 className="mt-5 font-display text-4xl md:text-6xl font-extrabold tracking-tighter leading-[0.95] max-w-[16ch]">
              {ABOUT.heading}
            </h2>
          </Reveal>
          <div className="mt-6 space-y-4 max-w-[52ch]">
            {ABOUT.paragraphs.map((p, idx) => (
              <Reveal i={idx} key={idx}>
                <p className="font-body text-black/65 leading-relaxed">{p}</p>
              </Reveal>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-px bg-black/10 border border-black/10 rounded-2xl overflow-hidden max-w-md">
            {ABOUT.stats.map((s) => (
              <div key={s.label} className="bg-[#FDFCF8] p-5">
                <div className="font-display text-3xl font-extrabold tracking-tight text-[#3A53A3]">{s.value}</div>
                <div className="mt-1 font-body text-xs text-black/55">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Image + Digimonk WhatsApp-bot card */}
        <div className="space-y-5">
          <Reveal>
            <div className="relative overflow-hidden rounded-[1.75rem] border border-black/10">
              <img src={IMAGES.team} alt="DNA Digital team" className="w-full h-[360px] object-cover" />
            </div>
          </Reveal>

          <Reveal i={1}>
            <motion.div
              whileHover={{ y: -4 }}
              className="rounded-[1.5rem] border border-[#25D366]/30 bg-[#0A0A0A] p-7 text-white overflow-hidden relative"
              data-testid="digimonk-card"
            >
              <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-[#25D366]/20 blur-2xl" />
              <div className="flex items-center gap-2 text-[#25D366]">
                <Bot className="h-5 w-5" />
                <span className="font-body text-xs font-bold uppercase tracking-[0.2em]">Our AI Arm · Digimonk</span>
              </div>
              <h3 className="mt-4 font-display text-2xl font-bold tracking-tight">
                WhatsApp bots that sell while you sleep.
              </h3>
              <p className="mt-2 font-body text-sm text-white/60 leading-relaxed max-w-[42ch]">
                Automate lead qualification, support and re-engagement with AI-powered WhatsApp agents built by our sister company, Digimonk.
              </p>
              <a
                href={DIGIMONK_SITE}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="digimonk-cta-button"
                className="group mt-6 inline-flex items-center gap-3 rounded-full bg-[#25D366] pl-6 pr-2.5 py-2.5 text-black font-body font-semibold"
              >
                Explore Digimonk AI
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-black transition-transform duration-500 group-hover:rotate-45">
                  <ArrowUpRight className="h-4 w-4 text-[#25D366]" />
                </span>
              </a>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
